import { ActionType } from '../../constants/ActionTypes'

export default function paymentsReducer(state = {}, action = {}) {

    switch (action.type) {

        case ActionType.CLEAR_PAYMENT_MESSAGES:
            return {
                ...state,
                error: { [action.payload]: null },
                success: { [action.payload]: null },
            }

        case ActionType.GET_PAYMENTS_BEGIN:
            return {
                ...state,
                error: null,
                success: null,
                isLoading: true,
                data: []
            }
        case ActionType.GET_PAYMENTS_ERROR:
            return {
                ...state,
                success: null,
                isLoading: false,
            }
        case ActionType.GET_PAYMENTS_SUCCESS:
            return {
                ...state,
                error: null,
                success: null,
                isLoading: false,
                data: action.payload
            }
        case ActionType.DO_DEPOSIT_BEGIN:
        case ActionType.DO_WITHDRAWAL_BEGIN:
            return {
                ...state,
                error: null,
                success: null,
                isLoading: true,
            }
        case ActionType.DO_WITHDRAWAL_ERROR:
            return {
                ...state,
                success: null,

                error: { [action.payload.id]: action.payload.error },
                isLoading: false,

            }
        case ActionType.DO_DEPOSIT_SUCCESS:
        case ActionType.DO_WITHDRAWAL_SUCCESS:
            return {
                ...state,
                error: null,
                success: { [action.payload.id]: action.payload.data },
                isLoading: false,

            }
        case ActionType.DO_DEPOSIT_ERROR:
            return {
                ...state,
                error: { [action.payload.id]: action.payload.error },
                success: null,
                isLoading: false,

            }
        case ActionType.PAYMENT_IFRAME_SUCCESS:
            return {
                ...state,
                error: null,
                success: null,
                isLoading: false
            }
        default:
            return state;
    }

}